var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{attrs:{"title":"页面不存在，请检查浏览器中的地址是否正确","type":"error"}})
}
var staticRenderFns = []

export { render, staticRenderFns }